import FeedMag from "./ListLayouts/FeedMag";
import Gallery from "./ListLayouts/Gallery";
import Headline from "./ListLayouts/Headline";
import Letterbox from "./ListLayouts/Letterbox";
import MediumList from "./ListLayouts/MediumList";
import MiniPolaroid from "./ListLayouts/MiniPolaroid";
import Polaroid from "./ListLayouts/Polaroid";
import SmallList from "./ListLayouts/SmallList";
import SocialList from "./ListLayouts/SocialList";
import TwoColList from "./ListLayouts/TwoColList";

const TILE_DATES = ["2 hours", "7 hours", "1 day", "2 days", "4 days", "1 week"];

const STACK_LAYOUTS = {
    smallList: SmallList,
    mediumList: MediumList,
    polaroid: Polaroid,
    letterbox: Letterbox,
    headline: Headline,
    feedMag: FeedMag,
};

const GRID_LAYOUTS = {
    '2columnList': { Component: TwoColList, columns: 2 },
    miniPolaroid: { Component: MiniPolaroid, columns: 2 },
    gallery: { Component: Gallery, columns: 3 },
};

const SOCIAL_DATES = ["34 mins", "2 hours", "7 hours", "1 day", "2 days", "4 days"];

const SOCIAL_TEXTS = [
    "Just a quick update for the team.",
    "A little something to share with everyone.",
    "Sharing a quick update today.",
    "Here's a little update from the team.",
    "Just checking in with a quick note.",
    "A small update, shared with everyone.",
];

const SOCIAL_AUTHORS = [
    { authorImage: "person-2.png", authorName: "Sarah Mitchell", authorRole: "People Manager", authorDepartment: "Internal Comms", likes: 5, comments: 2 },
    { authorImage: "person-5.png", authorName: "Emily Turner", authorRole: "HR Supervisor", authorDepartment: "HR", likes: 12, comments: 4 },
    { authorImage: "person-3.png", authorName: "Kate McGowan", authorRole: "Team Lead", authorDepartment: "Operations", likes: 8, comments: 1 },
    { authorImage: "person-4.png", authorName: "Ava Davis", authorRole: "Store Manager", authorDepartment: "Retail", likes: 20, comments: 6 },
    { authorImage: "person-1.png", authorName: "Joseph Smith", authorRole: "Client Executive", authorDepartment: "Sales", likes: 3, comments: 0 },
    { authorImage: "person-2.png", authorName: "Sarah Mitchell", authorRole: "People Manager", authorDepartment: "Internal Comms", likes: 15, comments: 3 },
];

const stackedRowStyle = { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", boxSizing: "border-box", marginTop: "28px" };
const gridRowStyle = { display: "flex", alignItems: "center", justifyContent: "space-between", boxSizing: "border-box", marginTop: "28px" };

function gridItemStyle(columns, col) {
    if (columns === 2) {
        return { maxWidth: "48%", minWidth: "48%", boxSizing: "border-box", ...(col === 0 ? { marginRight: "4%" } : {}) };
    }
    if (col === 1) {
        return { maxWidth: "31%", minWidth: "31%", boxSizing: "border-box", marginRight: "3%", marginLeft: "3%" };
    }
    return { maxWidth: "31%", minWidth: "31%", boxSizing: "border-box" };
}

function renderGrid(Component, columns, tiles, sharedProps) {
    const rows = [];
    for (let i = 0; i < tiles.length; i += columns) rows.push(tiles.slice(i, i + columns));

    return rows.map((row, rowIndex) => (
        <div key={rowIndex} className="featured-tiles" style={gridRowStyle}>
            {row.map((tile, col) => {
                const index = rowIndex * columns + col;
                return (
                    <label key={index} htmlFor={`listImage${index + 1}`} style={gridItemStyle(columns, col)}>
                        <Component image={tile.image} title={tile.title} date={TILE_DATES[index]} {...sharedProps} />
                    </label>
                );
            })}
        </div>
    ));
}

export default function Tiles({ listLayout, gradients, showIcons, displayDates, tablet, themeColour, tiles }) {

    if (listLayout === 'socialList') {
        return (
            <div className="featured-tiles" style={stackedRowStyle}>
                {tiles.map((tile, i) => (
                    <SocialList key={i} image={tile.image} title={tile.title} text={SOCIAL_TEXTS[i]} date={SOCIAL_DATES[i]} gradients={gradients} themeColour={themeColour} {...SOCIAL_AUTHORS[i]} />
                ))}
            </div>
        );
    }

    const grid = GRID_LAYOUTS[listLayout];
    if (grid) {
        return <>{renderGrid(grid.Component, grid.columns, tiles, { gradients, showIcons, displayDates, tablet })}</>;
    }

    const StackComponent = STACK_LAYOUTS[listLayout];
    if (StackComponent) {
        return (
            <div className="featured-tiles" style={stackedRowStyle}>
                {tiles.map((tile, i) => (
                    <StackComponent key={i} image={tile.image} title={tile.title} date={TILE_DATES[i]} gradients={gradients} showIcons={showIcons} displayDates={displayDates} tablet={tablet} />
                ))}
            </div>
        );
    }

    return <p>Nothing Found</p>;
}
